<template>
  <div class="modal fade text-left text-black" id="roomSlotUnavailable" ref="roomSlotUnavailable" tabindex="-1" data-backdrop="static" aria-labelledby="roomSlotUnavailableLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" :class="$deploymentIs('cryptology') ? 'heading' : ''" id="roomSlotUnavailableLabel">This Room Slot Is No Longer Available</h4>
          <button type="button" class="close btn-red" data-dismiss="modal" aria-label="Close">
            <h4 aria-hidden="true">&times;</h4>
          </button>
        </div>

        <div class="modal-body">
          <div class="alert alert-red">
            <p><span class="material-icons md-72 text-red">info</span> Sorry, this Room Slot is no longer available</p>
            <p class="mb-0">Please refresh and try again or <a :href="contactRoute" class="btn btn-purple">Contact Us</a></p>
          </div>
        </div>
        <div class="modal-footer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  computed: {
    contactRoute() {
      return this.location.locationContactHref;
    },
  },

  methods: {
    showModal() {
      console.log('booking-room-slot-unavailable-modal: showModal()');
      // Do any prep before showing the modal

      $(this.$refs.roomSlotUnavailable).modal('show');
    },

    hideModal() {
      $(this.$refs.roomSlotUnavailable).modal('hide');
    },
  },

  mounted() {
    // $(this.$refs.bookModal).on('hidden.bs.modal', this.bookModalHidden);
    // $(this.$refs.lockModal).on('hidden.bs.modal', this.lockModalHidden);
    // $(this.$refs.confirmModal).on('hidden.bs.modal', this.confirmModalHidden);

  },

  // beforeDestroy() {
  //   this.echoDeInitCart();
  // },
}
</script>
